var inlet = require('aem-libs/src/initInlet.js').initInlet(
  'AemTransparentAccount',
  /* global WEBPACK_INLET_VERSION */ WEBPACK_INLET_VERSION
)
var angular = require('angular')
require('angular-route')
require('aem-libs-angularjs/src/components/responsive-date-picker/responsive-date-picker.component.js')
require('aem-libs-angularjs/src/components/backend-error/backend-error.component.js')
require('aem-libs-angularjs/src/filters/empty-dash-formatter.filter.js')
require('aem-libs-angularjs/src/filters/currency-amount-formatter.filter.js')
var textToolsService = require('aem-libs-angularjs/src/services/text-tools.service.js').textToolsService
var contentService = require('aem-libs-angularjs/src/services/content.service.js').contentService
require('sticky-table-headers')
require('angular-cache')

angular.module('AemTransparentAccount', ['ngRoute', 'emptyDashFormatterCmp',
  'currencyAmountFormatterCmp', 'ResponsiveDatePickerCmp', 'angular-cache', 'BackEndErrorComp'])
  .factory('textToolsService', textToolsService)
  .factory('contentService', contentService)
  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider
      .when('/', {
        template: '<search></search>'
      })
      .when('/letter/:letter', {
        template: '<search></search>'
      })
      .when('/keyword/:keyword', {
        template: '<search></search>'
      })
      .when('/:accId', {
        template: '<results></results>'
      })
      .when('/:accId/:name', {
        template: '<results></results>'
      })
      .otherwise({
        redirectTo: '/'
      })
  }])

require('./inlet.css')
require('./inlet.controller.js')
require('./components/search/search.component.js')
require('./components/results/results.component.js')

require('aem-libs-angularjs/src/bootstrap').bootstrap({
  element: inlet.element,
  appName: 'AemTransparentAccount',
  mainCtrlName: 'AemTransparentAccountCtrl',
  basePath: inlet.basePath,
  config: /* global WEBPACK_INLET_CONFIG */ WEBPACK_INLET_CONFIG,
  supportedLanguages: {
    cs: require('./i18n/cs.js').cs,
    en: require('./i18n/en.js').en
  },
  html: require('./inlet.html')
})
